// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__ZMgy_","rootSuccess":"CompleteLink_rootSuccess__3NuMO","rootFailure":"CompleteLink_rootFailure__1Mjsd","isDisabled":"CompleteLink_isDisabled__hFiCa"};